<template lang="pug">
div(@click="$router.push(`/comic/${comic.id}`)").wrap-item-comic-card.py2.mb12.cursor-pointer
  div.wrap-img.relative.f.fh.overflow-hidden
    img(v-if="mainImg" :src="mainImg").object-fit-cover.h-full
    div(v-else).no-image.w-full.h-full.l0.t0
  div.wrap-info.py4
    div.f.fm.flex-between.mb2
      span.block.fz16.bold.mb4 {{comic.title}}
    span.fz14.line-clamp-2.mb4 {{comic.about}}
    div.f.fm
      div.genres.f.flex-wrap
        span(v-for="genre in comic.genres").genre.fz10.px8.py4.mr6.mb6 {{genre}}
      div.tags.f.flex-wrap
        span(v-for="tag in comic.tags").tag.fz10.px8.py4.mr6.mb6 {{`#${tag}`}}
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-item-comic-card {
  width: 49%;
  .wrap-img {
    .no-image {
      height: 300px;
      background: $tertiary_bg_color;
    }
  }
  .genres {
    .genre {
      // color: $dark_primary_text_color;
      background: $tertiary_bg_color;
    }
  }
  .genres, .tags {
    .genre, .tag {
      border-radius: 3px;
    }
    .tag {
      border: $basic_border;
    }
  }
  @media only screen and (max-width: $responsive_sp_width) {
    width: 100%;
  }
}
</style>

<script>
import database from '@/database'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')

export default {
  props: {
    comic: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapStateAuth(['uid']),
    mainImg () {
      return this.comic.mainImg ? this.comic.mainImg : this.comic.previewImg
    }
  },
  data () {
    return {

    }
  },
  async created () {

  },
  methods: {
    async onDelete () {
      alert('Under Construction')
    }
  }
}
</script>
